module.exports = __webpack_public_path__ + "static/scopriabitareco_valori_3_innovazione-3b95d666dbae72d060e93f203028c886.jpg";